import '../../../App.css';

import Button from "@mui/material/Button";
import PlainLink from "../PlainLink/PlainLink";

import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl';

function HomeFeatureButton(props) {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 415;
  React.useEffect(() => {
   const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => { window.removeEventListener("resize", handleResizeWindow); };
  }, []);

  return (
    <PlainLink to={props.to}>
      <Button
        style={width > breakpoint
          ? { height: "150px", width: "150px", marginBottom: "2rem", marginRight: "2rem" }
          : { height: "36vw", width: "36vw", marginBottom: "1rem", marginRight: "1rem" }
        }
        variant="contained"
      >
        <FontAwesomeIcon icon={props.icon ?? faListUl} className="dashboard-btn-icon" />
        <span className="dashboard-btn-title">
          {props.text}
        </span>
      </Button>
    </PlainLink>
  )
}

export default HomeFeatureButton;